import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import { renderRawHTML } from 'utils/formatters/html';
import { useTranslation } from 'react-i18next';
import marked from 'marked';
import { LocaleContext } from 'providers/locale-settings-context';
import { sluggify } from '../../../utils/localization/utils';
const renderer = new marked.Renderer();
renderer.link = function (href, title, text) {
    return '<a target="_blank" href="'.concat(href, '" title="', title, '">', text, '</a>');
};
const Comment = ({ comment: { author, timestamp, message, reasonCode, reasonDescription, meta = null, }, }) => {
    const { t } = useTranslation();
    const { formatDateTimeVerbal } = useContext(LocaleContext);
    let actualMessage = message;
    if (meta) {
        const { translations = [] } = meta;
        actualMessage = translations.reduce((acc, { slug, value, localizeValue }) => {
            acc += `${t(slug, {
                value: localizeValue ? t(sluggify(value)) : value,
            })} \n`;
            return acc;
        }, '');
    }
    try {
        actualMessage = renderRawHTML(marked(decodeURI(actualMessage), { renderer: renderer }));
    }
    catch (e) {
        try {
            actualMessage = unescape(actualMessage);
        }
        catch (e) {
            actualMessage = t('ISSUE_DECODING_COMMENT');
        }
    }
    return (React.createElement("div", { className: "border border-solid border-grey-lightest shadow p-4 bg-white" },
        React.createElement("p", { className: "mb-2 text-xs" },
            React.createElement("span", { className: "font-bold text-grey-darker" }, author),
            React.createElement("span", { className: "mx-1" }, "\u00B7"),
            React.createElement("span", { className: "text-grey-dark" }, formatDateTimeVerbal(timestamp))),
        React.createElement("div", { className: "break-words whitespace-pre-wrap text-grey-darker" }, actualMessage),
        reasonCode && reasonCode.length && (React.createElement("p", { className: "text-grey-darker" }, t('REASON_WITH_VALUE', { value: t(sluggify(reasonCode)) }))),
        reasonDescription && reasonDescription.length && (React.createElement("p", { className: "text-grey-darker" }, t('DESCRIPTION_WITH_VALUE', { value: reasonDescription })))));
};
Comment.propTypes = {
    comment: PropTypes.shape({
        author: PropTypes.string,
        timestamp: PropTypes.string,
        message: PropTypes.string,
    }).isRequired,
};
export default Comment;
